import css from './index.module.scss';
import { BoxContainer, TextField } from '@components/common';
import { Controller, useFormContext } from 'react-hook-form';
import { IconNode } from '@components/base';
import Images from '@assets/images';

const Identifiers = () => {
  const { control } = useFormContext();
  return (
    <BoxContainer className={css.mainWrapper} title="Identifiers">
      <div className={css.boxWrapper}>
        <div className={css.rowWrapper}>
          <Controller
            name="identifiers.invoiceNumber"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Invoice Number"
                placeholder="Invoice Number"
                disabled
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="identifiers.quoteNumber"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Quote Number"
                placeholder="Quote Number"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
      </div>
    </BoxContainer>
  );
};

export default Identifiers;
